import { FC, useCallback, useMemo } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { ProgressButton } from '@beeline/design-system-react/extracted-styles';

import { TooltipWrapper } from 'src/components/TooltipWrapper/TooltipWrapper';
import {
  getParkingDateError,
  getParkingTimeError,
} from 'src/store/parking/selectors';

export interface BookActionsProps {
  disabledReason?: string;
}

export const BookActions: FC<BookActionsProps> = ({ disabledReason }) => {
  const { submit } = useForm();
  const dateError = useSelector(getParkingDateError);
  const timeError = useSelector(getParkingTimeError);

  const book = useCallback(async () => {
    const result = await submit();
    if (!result) throw new Error('Form is invalid');
  }, [submit]);

  const button = useMemo(() => {
    return (
      <ProgressButton
        variant='contained'
        onClick={book}
        fullWidth
        disabled={!!(dateError || timeError || disabledReason)}
        data-testid='bookParking'
      >
        Забронировать
      </ProgressButton>
    );
  }, [book, dateError, disabledReason, timeError]);

  return disabledReason ? (
    <TooltipWrapper title={disabledReason}>{button}</TooltipWrapper>
  ) : (
    button
  );
};
